import { RadioGroup } from '@material-ui/core';
import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  container: {
    minWidth: '190px',
    boxShadow: 'inset -1px 0px 0px #e2ebf6',
    padding: '30px 0 0 30px',
    [theme.breakpoints.down('sm')]:{
    //  display: 'none'
    }
  
  },
  
  title: {
    padding: '0 0 24px'
  },
  label: {
    marginBottom: '20px'
  },
  labelName: {
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 'normal',
    color: '#000000',
    marginBottom: '4px'
  },
  labelInstruction: {
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 'normal',
    color: '#000000'
  },
  checkedLabel: {
    color: '#000000',
    fontWeight: '500'
  },
  rootCheckbox: {
    color: '#99adbd'
  },
  checked: {
    color: '#1d9dc6'
  },
  radioGroup: {
   
    [theme.breakpoints.down('sm')]:{
       width: '100%',
      flexDirection:'row',
    }
  },
}));
